export default {"frames": [

{
	"filename": "01_two-eyes.png",
	"frame": {"x":1,"y":411,"w":405,"h":364},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":70,"y":79,"w":405,"h":364},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "02_two-eyes.png",
	"frame": {"x":1,"y":1,"w":400,"h":408},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":77,"y":80,"w":400,"h":408},
	"sourceSize": {"w":512,"h":512}
},
{
	"filename": "03_two-eyes.png",
	"frame": {"x":403,"y":1,"w":401,"h":375},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":77,"y":80,"w":401,"h":375},
	"sourceSize": {"w":512,"h":512}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "two-eye.png",
	"format": "RGBA8888",
	"size": {"w":1024,"h":1024},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:6af93ff70da70a0c47370c73523741b1:a18e35e97f52345dfa44ed34a0ea2328:ab81c863f61ea3efb26820ebf9dfe015$"
}
}
